import type { ReactNode } from "react";
import { AlertCircle } from "@/components/icons";
import { cn } from "@/lib/utils";

interface FormErrorProps {
  children?: ReactNode;
  className?: string;
  id?: string;
}

export function FormError({ children, className, id }: FormErrorProps) {
  if (!children) return null;
  return (
    <p
      id={id}
      role="alert"
      className={cn("flex items-start gap-1.5 text-xs text-red-400", className)}
    >
      <AlertCircle aria-hidden="true" size={12} className="mt-0.5 shrink-0" />
      <span>{children}</span>
    </p>
  );
}
